/**
 * SignupRoleSelectPage — A-3-1 / A-4-1. 일반(아이디) 회원가입 유형 선택
 * 진입: SignupEntryPage → [인디피아 아이디로 가입] → /signup/id
 * 분기: 사장님 → /signup/master / 소속 직원 → /signup/staff
 */
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '@indipia/ui-core';
import { AuthLayout } from '../../app/layouts/AuthLayout';
import { RoleSelectCards, type SignupRole } from '../components/RoleSelectCards';

export function SignupRoleSelectPage() {
  const navigate = useNavigate();
  const [role, setRole] = useState<SignupRole>('master');

  const handleNext = () => {
    void navigate(role === 'master' ? '/signup/master' : '/signup/staff');
  };

  return (
    <AuthLayout
      kicker="회원가입"
      title="가입 유형을 선택해 주세요"
      subtitle="역할에 따라 가입 절차가 달라집니다."
      align="center"
      actions={
        <div className="flex gap-sm">
          {/* 보조 강조 액션은 secondary(아웃라인) — D-09 §15.1 Variants */}
          <Button variant="secondary" size="lg" className="shrink-0" onClick={() => void navigate('/signup')}>
            ← 이전
          </Button>
          <Button variant="primary" size="lg" className="flex-1" onClick={handleNext}>
            다음 →
          </Button>
        </div>
      }
    >
      <RoleSelectCards value={role} onChange={setRole} />
    </AuthLayout>
  );
}
